// extracted by mini-css-extract-plugin
export default {"wrapper":"xg2jm3","button":"_oNAcQ","large":"iIufo9","seoHide":"iSML_b"};